import { EntityState } from '@reduxjs/toolkit'
import { customFieldOptionsAdapter } from './customFieldOptionsSlice'
import type {
  CustomField,
  CustomFieldDTO,
  CustomFieldType,
  CustomFieldOption,
} from '@sales-center/common'

export function getFieldOptions(field: CustomFieldDTO): CustomFieldOption[] {
  const opts = field.options ?? []

  return opts.map((opt) => ({
    fieldId: field.id,
    ...opt,
  }))
}

export function aggregateFieldOptions(
  fieldId: CustomField['id'],
  options: CustomFieldOption[],
) {
  return options.filter((x) => x.fieldId === fieldId)
}

export function removeOptions(
  state: EntityState<CustomFieldOption>,
  fieldId: number,
) {
  customFieldOptionsAdapter.removeMany(
    state,
    customFieldOptionsAdapter
      .getSelectors()
      .selectAll(state)
      .filter((x) => x.fieldId === fieldId)
      .map((x) => x.id),
  )
}

export function readableFieldType(type: CustomFieldType): string {
  switch (type) {
    case 'DropdownMultiSelect':
      return 'Multi Select'
    case 'DropdownSingleSelect':
      return 'Single Select'
    default:
      return type
  }
}
